import { FormProvider, useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import cookie from 'js-cookie';
import { AddApplicantNavigationLinks } from './layout-links';
import Axios from '~/utils/axios';
import { FormNavigation } from './navigation';
import { Section } from '../common/section';
import { SubmitLoader } from '../common/loaders/submit';
import { Translate } from '~/i18n';
import { useRouter } from 'next/router';
import PasswordPromptModal from '../common/PasswordPromptModal';

export const AddApplicantLayout = ({ children }: { children: React.ReactNode }) => {
   const methods = useForm();
   const { query } = useRouter();
   const [state, setState] = useState({
      data: {},
      loading: !!query.applicationNo,
   });
   const pswdCookies = cookie.get(`${process.env.NEXT_PUBLIC_PASSWORD_COOKIE_NAME}`);
   const isPswdVerified = !!pswdCookies;

   useEffect(() => {
      const getVisaRequestsDetails = async () => {
         const { data } = await Axios.get(
            `/dhamen/v1/visa-request/${String(query.id)}/visitors/details/${String(
               query.applicationNo
            )}`
         );
         methods.reset({
            ...data,
         });
         setState({
            data,
            loading: false,
         });
      };
      if (query.applicationNo) {
         getVisaRequestsDetails();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [query.id]);

   if (process.env.NEXT_PUBLIC_HAS_PRIVATE_ROUTES === 'true' && !isPswdVerified) {
      return <PasswordPromptModal />;
   }

   return (
      <FormProvider {...methods}>
         <div className="relative flex p-2 md:p-5">
            <div className="inset-x-0 lg:block hidden flex-shrink-0 lg:w-[260px] ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4">
               <Section className="h-full !bg-transparent shadow-none">
                  <div className="fixed lg:w-[245px]">
                     <span className="relative mb-2 text-lg font-bold text-primary">
                        <Translate id="visasManager:create an umrah trip" />
                        <div className="h-1 w-[40px] absolute border-b-2 border-primary ltr:left-0 rtl:right-0 mt-1.5"></div>
                     </span>
                     <p className="mt-5 mb-5 text-sm text-gray-500">
                        <Translate id="visasManager:create a umrah description" />
                     </p>

                     <div>
                        <FormNavigation NavigationLinks={AddApplicantNavigationLinks} />
                     </div>
                  </div>
               </Section>
            </div>
            <div className="flex-grow">
               <Section className="px-4 pt-6 pb-1 mb-20 md:px-8">
                  {state.loading ? <SubmitLoader /> : children}
               </Section>
            </div>
         </div>
      </FormProvider>
   );
};
